export default {
  signalsNotFound: 'Nasledujúce signály sa nenašli: {signalNames}',
};
